import React, { useMemo } from 'react'

import { getRpcUrlByNetworkId } from '@optimex-xyz/trade-wallet-sdk'
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { IS_PROD, SUPPORTED_NETWORK } from '@/utils'
import { wagmiConfig } from '@/wallets/types/wagmi.type'

import { Adapter } from 'node_modules/@solana/wallet-adapter-base/lib/types/types'
import { WagmiProvider as EvmProvider } from 'wagmi'

const wallets: Adapter[] = []
const SolanaProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const network = IS_PROD ? SUPPORTED_NETWORK.SOLANA : SUPPORTED_NETWORK.SOLANA_DEVNET
  const endpoint = useMemo(() => getRpcUrlByNetworkId(network), [network])

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider autoConnect wallets={wallets}>
        {children}
      </WalletProvider>
    </ConnectionProvider>
  )
}

const queryClient = new QueryClient()

const WalletConnectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <EvmProvider config={wagmiConfig as any}>
      <QueryClientProvider client={queryClient}>
        <SolanaProvider>{children}</SolanaProvider>
      </QueryClientProvider>
    </EvmProvider>
  )
}
export default WalletConnectProvider
